// Karussell-Navigation fuer Wirkstoff-Detail Produkt-Cards.
// Mobile: Pfeil-Klick + aria-disabled. Touch-Swipe via CSS scroll-snap.
// Desktop: Pfeile via CSS hidden, JS hat dort keine Wirkung.
//
// Klon von assets/dog1-product-cross-sell.js mit data-wp-* Selektor-Namespace.
// Backlog-Notiz: JS-Generalisierungs-Refactor (analog Cross-Sell + Bestseller)
// als spaeteres Cluster-Vorhaben.

(function () {
  'use strict';

  const karussells = document.querySelectorAll('[data-wp-karussell]');

  karussells.forEach((karussell) => {
    const list = karussell.querySelector('[data-wp-karussell-list]');
    const navPrev = karussell.querySelector('[data-wp-nav="prev"]');
    const navNext = karussell.querySelector('[data-wp-nav="next"]');

    if (!list || !navPrev || !navNext) return;

    const getScrollAmount = () => {
      const item = list.querySelector('.dog1-wirkstoff__product-item');
      if (!item) return 0;
      const gap = parseFloat(window.getComputedStyle(list).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    };

    const getScrollBehavior = () =>
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';

    const updateNavState = () => {
      const scrollLeft = list.scrollLeft;
      const maxScroll = list.scrollWidth - list.clientWidth;

      const isAtStart = scrollLeft <= 1;
      navPrev.disabled = isAtStart;
      navPrev.setAttribute('aria-disabled', String(isAtStart));

      const isAtEnd = scrollLeft >= maxScroll - 1;
      navNext.disabled = isAtEnd;
      navNext.setAttribute('aria-disabled', String(isAtEnd));
    };

    navPrev.addEventListener('click', () => {
      list.scrollBy({ left: -getScrollAmount(), behavior: getScrollBehavior() });
    });

    navNext.addEventListener('click', () => {
      list.scrollBy({ left: getScrollAmount(), behavior: getScrollBehavior() });
    });

    list.addEventListener('scroll', updateNavState);

    updateNavState();

    window.addEventListener('resize', updateNavState);
  });
})();
